// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__UwhoY","title":"ClientCherryInfo_title__3r_5u","itemText":"ClientCherryInfo_itemText__1L9XW"};